import { FileUploader } from '@ps20-frontend/frontend-models';
import { UwContext, UwContextDescriptor, UwPrintField, UwSubmissionField } from '../uw-context.model';

export interface NaturalHazardsProdukt {
  nebengebaeudeUeber200?: boolean;
  extremwetterRisk?: boolean;
  hasVorschaeden?: boolean;
  selectedZusatzoptionen?: Array<{ id: string }>;
}

const GRUND_KEY_PREFIX = 'anfragepflichtigeInformationen.underwriterDecision.confirmation.grund';

export function buildNaturalHazardsReason(produkt: NaturalHazardsProdukt): string {
  const nebengebaeude = produkt.nebengebaeudeUeber200 === true;
  const extremwetter = produkt.extremwetterRisk === true;

  if (nebengebaeude && extremwetter) {
    return produkt.hasVorschaeden
      ? `${GRUND_KEY_PREFIX}.nebengebaeudeZoneDreiMitVorschaeden`
      : `${GRUND_KEY_PREFIX}.nebengebaeudeZoneVier`;
  }
  if (nebengebaeude) {
    return `${GRUND_KEY_PREFIX}.nebengebaeude`;
  }
  return produkt.hasVorschaeden
    ? `${GRUND_KEY_PREFIX}.zoneDreiMitVorschaeden`
    : `${GRUND_KEY_PREFIX}.zoneVier`;
}

export function isNaturalHazardsRiskBlocking(produkt: NaturalHazardsProdukt): boolean {
  return produkt.selectedZusatzoptionen?.some(option => option.id === 'weitereNaturgefahren') === true;
}

export const naturalHazardsDescriptor: UwContextDescriptor<NaturalHazardsProdukt> = {
  key: UwContext.NATURAL_HAZARDS,
  ordinal: 1,
  isBlockingRisk: isNaturalHazardsRiskBlocking,
  buildReason: buildNaturalHazardsReason,
  uploader: FileUploader.ELEMENTAR_FRAGEBOGEN,
  textFields: [
    {
      id: 'comment',
      labelKey: 'anfragepflichtigeInformationen.textarea.label',
      required: false,
      maxLength: 500,
      pattern: 'TEXTFIELD_WITH_NEWLINE_BESONDERHEITEN',
    },
  ],
  i18n: {
    title: 'anfragepflichtigeInformationen.card.addressTitle',
    reason:
      'anfragepflichtigeInformationen.underwriterDecision.confirmation.grund.zoneRiskExtremeCondition',
    rejectionMeasure:
      'anfragepflichtigeInformationen.underwriterDecision.rejection.removeExtremwetterschutz',
  },
  wire: {
    submissionField: UwSubmissionField.NATURAL_HAZARDS,
    printField: UwPrintField.NATURAL_HAZARDS,
  },
  copy: {
    requiredForTitle: 'anfragepflichtigeInformationen.card.requiredForTitle',
    uploadSectionTitle: 'anfragepflichtigeInformationen.card.uploadTitle',
    uploadSectionHint: 'anfragepflichtigeInformationen.card.uploadText',
    uploadRequiredErrorKey: 'anfragepflichtigeInformationen.card.fileUpload.required',
    uploadRequiredErrorDataCy: 'elementarfragebogen-file-upload-required-error',
    readonlyTitle: 'anfragepflichtigeInformationen.elementarfragebogenReadonly.title',
    readonlyFieldLabels: {
      comment: 'anfragepflichtigeInformationen.underwriterDecision.confirmation.agentRemarks',
    },
    templateDownload: {
      hrefKey: 'anfragepflichtigeInformationen.dokumentenupload.link',
      labelKey:
        'anfragepflichtigeInformationen.vwgAngaben.elementarfragebogen.download.pdf.label',
    },
    downloadErrorDataCyPrefix: 'file-download-error-',
  },
  readonlyCard: { showFilesTitle: true },
  fieldDataCy: {
    comment: {
      errorLength: 'checkout-besonderheiten-error-length',
      errorPattern: 'checkout-besonderheiten-error-pattern',
    },
  },
};
